module.exports = __webpack_public_path__ + "static/media/adv-13.89cbe206.png";